import { getList, getDetail } from '../api';
import { queryOptions } from '@tanstack/react-query'
import { Search } from '../schemas/search';



interface SearchQueryType {
    key?: string
    search: Search
    enabled?: boolean
}



export function searchQueryOptions({ key, search, enabled = true }: SearchQueryType) {
    return queryOptions({
        queryKey: [key, search],
        queryFn: () => getList(search),
        staleTime: 10 * 1000,
        enabled,
    })
}

export function detailQueryOptions({ detailKey, id }: {
    detailKey?: string
    id?: string
}) {
    return queryOptions({
        queryKey: [detailKey, id],
        queryFn: () => getDetail(id ?? ""),
        staleTime: 10 * 1000
    })
}
